<h1 mat-dialog-title>Task Details</h1>
<div mat-dialog-content>
    <div class="p-t-20 field-column">

        <mat-form-field appearance="outline">
            <mat-label>Date</mat-label>
            <input matInput [matDatepicker]="taskDialogDatePicker" [(ngModel)]="model.date" placeholder="DD/MM/YYYY"
                [max]="todayDate">
            <mat-datepicker-toggle matSuffix [for]="taskDialogDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #taskDialogDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Due Date</mat-label>
            <input matInput [matDatepicker]="taskDialogDueDatePicker" [(ngModel)]="model.dueDate"
                placeholder="DD/MM/YYYY" [min]="todayDate">
            <mat-datepicker-toggle matSuffix [for]="taskDialogDueDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #taskDialogDueDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Task</mat-label>
            <input matInput [(ngModel)]="model.task">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Assigned to</mat-label>
            <mat-select [(ngModel)]="model.assigneeUserIds" multiple placeholder="Everyone">
                <mat-option *ngFor="let member of members" [value]="member.userId">{{ member.name }}</mat-option>
            </mat-select>
            <mat-hint>Leave empty to assign to everyone in the practice.</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Notes</mat-label>
            <textarea *ngIf="data?.aiGenerated; else plainNotes" matInput appFindReplace cdkTextareaAutosize="true"
                rows="10" [(ngModel)]="model.notes"></textarea>
            <ng-template #plainNotes>
                <textarea matInput cdkTextareaAutosize="true" rows="10" [(ngModel)]="model.notes"></textarea>
            </ng-template>
        </mat-form-field>

        <p class="hint" *ngIf="data?.aiGenerated">Note: MedicAI can make mistakes. We advise that you check the content
            of the output carefully before accepting it into the patient file.</p>
    </div>
</div>
<div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="!canSave" (click)="save()">Save</button>
</div>
